import { createContext } from "react";

export interface DrawerContextType {
  isOpen: boolean;
  openDrawer: () => void;
  closeDrawer: (open?: boolean) => void;
}

export const DrawerContext = createContext<DrawerContextType | undefined>(
  undefined
);
